import React from 'react';
import './MergeOrder.less';
import ItemsComp from './itemsComp/ItemsComp';

export interface mergeOrderPropsType {
    prefixCls?: string;
    isShow?: boolean;
    onCloseBox?: () => void;
    data: any[];
    onEnterClick?: (data?) => void;
    clickFlag?: any; // 状态
}

class MergeOrder extends React.Component<mergeOrderPropsType, any> {
    static defaultProps = {
        prefixCls: 'merge-order'
    };

    private showMsg(flag: any): string {
        let str: string = '';
        switch (flag) {
            case '支付':
                str = '支付该订单时，与该订单同时下单的订单将会一并支付。';
                break;
            case '取消':
                str = '取消该订单时，与该订单同时下单的订单将会一并取消。';
                break;
            case '删除':
                str = '删除该订单时，与该订单同时下单的订单将会一并删除。';
                break;
        }
        return str;
    }

    render() {
        const {prefixCls, isShow, onCloseBox, data, onEnterClick, clickFlag} = this.props; // data
        let price: number = 0;
        data.forEach(item => {
            price += item.totalFee
        });
        return (
            <div>
                <div className={`${prefixCls}-cover`} onClick={onCloseBox}/>
                <div className={isShow ? `${prefixCls}-mergeBox` : `${prefixCls}-mergeBox-ani`}>
                    <div className={`${prefixCls}-message`}>{this.showMsg(clickFlag)}</div>
                    <div className={`${prefixCls}-mergeBox-close`} onClick={onCloseBox}/>
                    <div className={`${prefixCls}-mergeBox-scroll claerfix`}>
                        {
                            data.map((item: any) => {
                                return (
                                    <ItemsComp data={item} key={item.id}/>
                                )
                            })
                        }
                    </div>
                    <div className={`${prefixCls}-mergeBox-btn`} onClick={() => {onEnterClick && onEnterClick(data)}}>
                        确定{clickFlag}
                        <span>{clickFlag !== '删除' && `￥${price.toFixed(2)}`}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default MergeOrder;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/mergeOrder/MergeOrder.tsx